export default __webpack_public_path__ + "static/media/alvaroAvatar.88e02091.jpg";